import { createTheme } from "@mui/material/styles";

const smarTracksMapTheme = createTheme({
  palette: {
    primary: { main: "#F49C08" },
    secondary: { main: "#FFFFFF" },
    error: { main: "#FA5E05" },
  },
  typography: {
    fontFamily: ["Ubuntu", "sans-serif"].join(","),
    fontSize: 13,
  },
  shape: {
    borderRadius: 2,
  },
  spacing: 5,
  components: {
    MuiList: {
      defaultProps: {
        dense: true,
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        // MUI 9 shrank this from 56px; the location info list is laid out for 56
        root: { minWidth: 56 },
      },
    },
    MuiMenuItem: {
      defaultProps: {
        dense: true,
      },
    },
    MuiTable: {
      defaultProps: {
        size: "small",
      },
    },
    MuiButton: {
      defaultProps: {
        size: "small",
      },
    },
    MuiButtonGroup: {
      defaultProps: {
        size: "small",
      },
    },
    MuiCheckbox: {
      defaultProps: {
        size: "small",
      },
    },
    MuiFab: {
      defaultProps: {
        size: "small",
      },
    },
    MuiFormControl: {
      defaultProps: {
        margin: "dense",
        size: "small",
      },
    },
    MuiFormHelperText: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiIconButton: {
      defaultProps: {
        size: "small",
      },
    },
    MuiInputBase: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiInputLabel: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiRadio: {
      defaultProps: {
        size: "small",
      },
    },
    MuiSwitch: {
      defaultProps: {
        size: "small",
      },
    },
    MuiTextField: {
      defaultProps: {
        margin: "dense",
        size: "small",
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 540,
      md: 768,
      lg: 1280,
      xl: 1920,
    },
  },
});

export default smarTracksMapTheme;
